export const DEV = '🦑';
